module.exports = __webpack_public_path__ + "static/media/montana-compressed.b5b76ed7.jpg";